module.exports = __webpack_public_path__ + "media/images/amenities_icons/volleyball_court-cd1c35c79508f9cadb2a4efd7006cdfd.svg";